class PawtureSupport extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    const search = this.querySelector('[data-faq-search]');
    const items = [...this.querySelectorAll('[data-faq-item]')];
    let category = 'All Questions';
    const filter = () => {
      const word = (search?.value || '').trim().toLocaleLowerCase();
      let count = 0;
      items.forEach(item => {
        const matched = (category === 'All Questions' || item.dataset.category === category) && (!word || `${item.dataset.category} ${item.textContent}`.toLocaleLowerCase().includes(word));
        item.hidden = !matched;
        if (matched) count++;
      });
      const output = this.querySelector('[data-faq-count]');
      if (output) output.textContent = output.dataset.countLabel.replace('[count]', String(count));
      const empty = this.querySelector('[data-faq-empty]');
      if (empty) empty.hidden = count > 0;
    };
    search?.addEventListener('input', filter);
    this.querySelectorAll('[data-faq-category]').forEach(button => button.addEventListener('click', () => {
      category = button.dataset.faqCategory;
      this.querySelectorAll('[data-faq-category]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      filter();
    }));
    filter();
    const tabs = [...this.querySelectorAll('[data-size-tab]')];
    const setPet = pet => {
      tabs.forEach(tab => {
        const selected = tab.dataset.sizeTab === pet;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      this.querySelectorAll('[data-size-panel]').forEach(panel => { panel.hidden = panel.dataset.sizePanel !== pet; });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => setPet(tab.dataset.sizeTab));
      tab.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const target = event.key === 'Home' ? tabs[0] : event.key === 'End' ? tabs.at(-1) : tabs[(index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        setPet(target.dataset.sizeTab);
        target.focus();
      });
    });
    const selects = [...this.querySelectorAll('[data-guide-select]')];
    const selectChart = select => {
      const panel = select.closest('[data-size-panel]');
      panel.querySelectorAll('[data-guide-chart]').forEach(chart => { chart.hidden = chart.dataset.guideChart !== select.value; });
    };
    selects.forEach(select => { select.addEventListener('change', () => selectChart(select)); selectChart(select); });
    const params = new URLSearchParams(location.search);
    const product = params.get('product');
    if (product) selects.forEach(select => {
      if ([...select.options].some(option => option.value === product)) { select.value = product; selectChart(select); setPet(select.dataset.guideSelect); }
    });
    const dialog = this.querySelector('[data-chart-dialog]');
    let opener;
    this.querySelectorAll('[data-open-chart]').forEach(button => button.addEventListener('click', () => {
      const chart = button.closest('[data-size-panel]').querySelector('[data-guide-chart]:not([hidden])');
      if (!chart || !dialog) return;
      opener = button;
      dialog.querySelector('[data-chart-content]').replaceChildren(chart.cloneNode(true));
      dialog.showModal();
    }));
    this.querySelector('[data-close-chart]')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('close', () => opener?.focus());
    dialog?.addEventListener('click', event => {
      const rect = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
    });
    const topic = this.querySelector('#SupportTopic');
    if (topic && [...topic.options].some(option => option.value === params.get('topic'))) topic.value = params.get('topic');
    this.querySelector('[data-contact-success], [data-contact-errors]')?.focus();
  }
}
if (!customElements.get('pawture-support')) customElements.define('pawture-support', PawtureSupport);
